import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import iccMarketService from '@/services/icc/iccMarketService';
import {selectGigyaToken} from '@/state/selectors/auth';
import {selectConsumerFetchDate} from '@/state/selectors/consumer';

const REFETCH_TIME_MS = 30 * 60 * 1000;

const useRefetchExternalConsumerProfile = () => {
    const fetchDate = useSelector(selectConsumerFetchDate);
    const gigyaToken = useSelector(selectGigyaToken);

    useEffect(() => {
        const isDataOutdated = !fetchDate || new Date() - fetchDate > REFETCH_TIME_MS;

        if (!isDataOutdated) return;

        iccMarketService.getExternalConsumerProfile(gigyaToken);
    }, [fetchDate]);
};

export default useRefetchExternalConsumerProfile;
